// ================================
// BRAAAP MOTO — Shopify Theme JS
// ================================

document.addEventListener('DOMContentLoaded', function () {

  // --------------------------------
  // Hero Slideshow
  // --------------------------------
  const slides = document.querySelectorAll('.slide');
  let currentSlide = 0;

  if (slides.length > 1) {
    function nextSlide() {
      slides[currentSlide].classList.remove('active');
      slides[currentSlide].style.transform = 'scale(1.08)';
      currentSlide = (currentSlide + 1) % slides.length;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          slides[currentSlide].classList.add('active');
        });
      });
    }
    setInterval(nextSlide, 6000);
  }

  // --------------------------------
  // Navbar scroll effect
  // --------------------------------
  const navbar = document.querySelector('.navbar');
  if (navbar) {
    window.addEventListener('scroll', () => {
      navbar.style.borderBottomColor = window.scrollY > 80
        ? 'rgba(255, 107, 0, 0.4)'
        : 'rgba(255, 107, 0, 0.2)';
    });
  }

  // --------------------------------
  // Hamburger menu
  // --------------------------------
  const hamburger = document.getElementById('hamburger');
  const navLinks = document.querySelector('.nav-links');

  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('mobile-open');
      Object.assign(navLinks.style, isOpen ? {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: '70px',
        left: '0',
        right: '0',
        background: 'rgba(10,10,10,0.98)',
        padding: '20px 24px',
        borderBottom: '1px solid rgba(255,107,0,0.2)',
        zIndex: '999'
      } : { display: '' });
    });
  }

  // --------------------------------
  // Shopify AJAX Cart — Quick Add & Add to Cart
  // --------------------------------
  function addToCart(variantId, button) {
    if (!variantId) return;
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      button.textContent = 'Added!';
      // Update cart count badge
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) cartCount.textContent = cart.item_count;
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
    })
    .catch(err => {
      console.error('Cart error:', err);
      button.textContent = originalText;
      button.disabled = false;
    });
  }

  // Delegate click events for add-to-cart and quick-add buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.add-to-cart, .quick-add');
    if (!btn) return;
    const variantId = btn.dataset.productId;
    if (variantId) {
      e.preventDefault();
      addToCart(variantId, btn);
    }
  });

  // --------------------------------
  // Smooth scroll for anchor links
  // --------------------------------
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // --------------------------------
  // Scroll reveal for product & category cards
  // --------------------------------
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .category-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

});
